// extracted by mini-css-extract-plugin
export default {"videoContainer":"videoContainer_E3UeW"};